import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import fileDownload from "js-file-download";
import Loader from "../pages/Loader";
import {
  getMyTimeSheetDetails,
  updateMyTimeCardStatus,
  getCrewUserByUserId,
  getOnlyCrews,
  getDaySummary,
  downloadReport,
  getUserDetails,
} from "../API";
import { formatToWeekYear, getStartEndDate } from "../utils/utils";
import AddNewTimeSheet from "./AddNewTimeSheet";
import checkIcon from "../assets/images/check.png";
import GreyTick from "../assets/images/Grey-tick.png";
import GreenTick from "../assets/images/Green-tick.png";
import DateRangePicker from "./common/DateRangePicker";
import { dateRangeValue } from "../redux/selectors/timeSheetDateRangeSelector";
import MyTimesheetFilters from "./MyTimesheetFilters";

const MyTimesheet = (props) => {
  // const { timeSheets, isLoading } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [csvLoading, setCsvLoading] = useState(false);
  const [timeSheetOpen, setTimeSheetOpen] = useState([]);
  const [timeSheetInReview, setTimeSheetInReview] = useState([]);
  const [timeSheetProcessing, setTimeSheetProcessing] = useState([]);
  const [foremanCrews, setForemanCrews] = useState([]);
  const [allCrews, setAllCrews] = useState([]);
  const [daySummary, setDaySummary] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [filterFields, setFilterFields] = useState({
    foreman: "",
    general_foreman: "",
    virtual_id: "",
  });
  const [isLoadingColor, setIsLoadingColor] = useState(false);

  const navigate = useNavigate();
  const role = localStorage.getItem("role_name");
  const user_id = JSON.parse(localStorage.getItem("user_id"));

  const weekDate = useSelector(dateRangeValue);
  const weekRangeFilter = weekDate?.endDate
    ? `week_start=${formatToWeekYear(
        weekDate?.startDate,
        "-"
      )}&week_end=${formatToWeekYear(weekDate?.endDate, "-")}`
    : "";

  const getUserOptions = async () => {
    await getUserDetails().then((res) => {
      const optionsArr = res?.data?.map((ele) => {
        return {
          label: ele?.name,
          value: ele?.name,
        };
      });
      setUserOptions(optionsArr);
    });
  };

  const constructQueryString = (filterFields) => {
    // Create query params only for non-empty fields
    const queryParams = Object.entries(filterFields)
      .filter(([key, value]) => value !== "") // Filter out empty fields
      .map(([key, value]) => {
        // Add the appropriate prefix for each key
        const formattedKey =
          key === "virtual_id" ? `crew/${key}` : `crew/_${key}`;
        return `${formattedKey}=${encodeURIComponent(value)}`;
      })
      .join("&"); // Join with `&`

    return queryParams;
  };

  const getTimeSheetDeatils = async () => {
    try {
      // setIsLoading(true);
      setFilterLoading(true);
      if (user_id) {
        setTimeSheetOpen([]);
        setTimeSheetInReview([]);
        setTimeSheetProcessing([]);
        await getCrewUserByUserId(user_id).then(async (res) => {
          const filterCrew = res?.data?.filter(
            (data) => data?.crew_role_id === 1
          );
          setForemanCrews(filterCrew);
          setIsLoading(false);
          setFilterLoading(false);
          const timeSheetDetails = filterCrew?.map((ele) => {
            const query =
              weekRangeFilter !== ""
                ? `crew_id=${ele?.crew_id}&${weekRangeFilter}`
                : `crew_id=${ele?.crew_id}`;
            return getMyTimeSheetDetails(query);
          });

          const userCrews = filterCrew?.map((ele) => {
            const data = {
              id: ele?.crew_id,
            };
            return getOnlyCrews(data);
          });
          // const query = `crew_id=${res?.data[0]?.crew_id}`;

          const data = await Promise.all(timeSheetDetails);
          const crewdata = await Promise.all(userCrews);

          const timeSheetArr = data?.flatMap((ele) => ele?.data);
          setIsLoadingColor(true);
          if (timeSheetArr?.length) {
            const filteredDaySummary = timeSheetArr?.filter(
              (item) => item?.time_sheet_status_id < 4
            );
            getDaySummary(filteredDaySummary).then((res) => {
              setIsLoadingColor(false);
              if (res?.data?.length) {
                setDaySummary(res?.data);
              }
            });
          }
          const crewDataArr = crewdata
            ?.filter((ele) => ele?.data[0]?.is_active === true)
            .map((item) => item?.data[0]);

          if (timeSheetArr) {
            timeSheetArr?.forEach((item) => {
              if (
                item?.time_sheet_status_id === 1 ||
                item?.time_sheet_status_id === 0
              ) {
                const customItem = {
                  ...item,
                  virtual_id: item?.crew?.virtual_id,
                };
                setTimeSheetOpen((previousValue) => [
                  ...previousValue,
                  customItem,
                ]);
              }
              if (
                item?.time_sheet_status_id === 2 ||
                item?.time_sheet_status_id === 3
              ) {
                setTimeSheetInReview((previousValue) => [
                  ...previousValue,
                  item,
                ]);
              }
              if (
                item?.time_sheet_status_id === 4 ||
                item?.time_sheet_status_id === 5
              ) {
                setTimeSheetProcessing((previousValue) => [
                  ...previousValue,
                  item,
                ]);
              }
            });
          }
          if (crewDataArr) {
            setAllCrews(crewDataArr);
          }
        });
      } else if (role === "Admin") {
        const queryFilter = constructQueryString(filterFields);
        setTimeSheetOpen([]);
        setTimeSheetInReview([]);
        setTimeSheetProcessing([]);
        await getMyTimeSheetDetails(`${weekRangeFilter}&${queryFilter}`).then(
          (res) => {
            setIsLoadingColor(true);

            if (res?.status === 200 && res?.data) {
              setIsLoading(false);
              setFilterLoading(false);
              const filteredDaySummary = res?.data?.filter(
                (item) => item?.time_sheet_status_id < 4
              );
              if (filteredDaySummary?.length > 0) {
                getDaySummary(filteredDaySummary).then((res) => {
                  setIsLoadingColor(false);
                  if (res?.data?.length) {
                    setDaySummary(res?.data);
                  }
                });
              }
              res?.data?.forEach((item) => {
                if (
                  item?.time_sheet_status_id === 1 ||
                  item?.time_sheet_status_id === 0
                ) {
                  // const crewData1 = allCrewDetails?.data?.find(
                  //   (ele) => item?.crew_id === ele?.id
                  // );
                  const customItem = {
                    ...item,
                    virtual_id: item?.crew?.virtual_id,
                  };
                  setTimeSheetOpen((previousValue) => [
                    ...previousValue,
                    customItem,
                  ]);
                }

                if (
                  item?.time_sheet_status_id === 2 ||
                  item?.time_sheet_status_id === 3
                ) {
                  // const crewData2 = allCrewDetails?.data?.find(
                  //   (ele) => item?.crew_id === ele?.id
                  // );
                  const customItem = {
                    ...item,
                    virtual_id: item?.crew?.virtual_id,
                  };
                  setTimeSheetInReview((previousValue) => [
                    ...previousValue,
                    customItem,
                  ]);
                }
                if (
                  item?.time_sheet_status_id === 4 ||
                  item?.time_sheet_status_id === 5
                ) {
                  // const crewData3 = allCrewDetails?.data?.find(
                  //   (ele) => item?.crew_id === ele?.id
                  // );
                  const customItem = {
                    ...item,
                    virtual_id: item?.crew?.virtual_id,
                  };
                  setTimeSheetProcessing((previousValue) => [
                    ...previousValue,
                    customItem,
                  ]);
                }
              });
            }
            const data = { query: "is_active=true" };
            getOnlyCrews(data).then((res) => {
              setAllCrews(res?.data);
            });
          }
        );
        // await fetchAllCrewUsers().then((res) => {
        //   setForemanCrews(res?.data);
        //   setAllCrews(res?.data);
        // });
      }
    } catch (error) {
      console.error("Error fetching timesheet details:", error);
      setIsLoading(false);
      setIsLoadingColor(false);
      setFilterLoading(false);
      toast.error("Failed to fetch timesheet details");
    } finally {
      setIsLoading(false);
      setIsLoadingColor(false);
      setFilterLoading(false);
    }
  };

  // const fetchAllProjects = async () => {
  //   const allProjectsList = await getAllProjectList();
  //   setProjectList(allProjectsList?.data);
  // };

  useEffect(() => {
    if (
      filterFields?.foreman ||
      filterFields?.general_foreman ||
      filterFields?.virtual_id
    ) {
      getTimeSheetDeatils();
    } else {
      setIsLoading(true);
      setFilterLoading(false);
      getTimeSheetDeatils();
    }
    // fetchAllProjects();
  }, [weekDate.endDate, filterFields]);

  useEffect(() => {
    getUserOptions();
  }, []);

  const refreshData = async () => {
    setTimeSheetOpen([]);
    setTimeSheetInReview([]);
    setTimeSheetProcessing([]);
    getTimeSheetDeatils();
  };

  const onCardClick = (card) => {
    navigate(`/timesheet-card/${card.id}`);
  };

  const onClickReturn = async (card) => {
    await updateMyTimeCardStatus(
      {
        time_sheet_status_id: 1,
      },
      card?.id
    ).then((res) => {
      if (res?.status === 200) {
        toast.success("Time Card Status Updated");
        setTimeSheetOpen([]);
        setTimeSheetInReview([]);
        setTimeSheetProcessing([]);
        getTimeSheetDeatils();
      }
    });
  };
  const displayWeeklyData = (crewId) => {
    const result = daySummary?.map((item) => {
      if (item?.data?.length > 0) {
        const data = item?.data
          ?.map((dataItem) => ({
            day: dataItem.day.charAt(0),
            color: dataItem.color,
            numeric: dataItem.dayNumeric,
            fontsize: dataItem.weight,
          }))
          .sort((a, b) => a.numeric - b.numeric);
        return { id: item?.time_sheet_id, data };
      } else {
        const data = {
          day: item?.day?.charAt(0),
          color: item?.color,
          numeric: item?.dayNumeric,
          fontsize: item?.weight,
        };
        return data;
      }
    });

    // for multiple day summaries
    if (result[0]?.id) {
      const crewData = result?.find((ele) => parseInt(ele?.id) === crewId);
      if (crewData) {
        const dayElements = crewData?.data?.map((day) => (
          <div
          // key={day?.day}
          // style={{ color: day?.color }}
          className="day"
        >
          <div className={`textDay weight-${day?.fontsize}`}>
              {day?.day}
            </div>
            <div className={`statusDay ${day?.color}`}></div>
        </div>
        ));

        return dayElements;
      }
    }
    // for single day summary
    else {
      const dayElements = result?.map((day) => (
        <div
          // key={day?.day}
          // style={{ color: day?.color }}
          className="day"
        >
          <div className={`textDay weight-${day?.fontsize}`}>
              {day?.day}
            </div>
            <div className={`statusDay ${day?.color}`}></div>
        </div>
      ));

      return dayElements;
    }
  };

  const onSubmitClick = async (card) => {
    const payload = {
      time_sheet_status_id: 2,
    };
    await updateMyTimeCardStatus(payload, card?.id).then((res) => {
      if (res?.status === 200) {
        toast.success("Time Card Status Updated");
        setTimeSheetOpen([]);
        setTimeSheetInReview([]);
        setTimeSheetProcessing([]);
        getTimeSheetDeatils();
      }
    });
  };

  const onClickDownloadReport = async (card) => {
    setCsvLoading(true);
    const payload = {
      week: card?.week,
      crew_id: card?.crew_id,
    };
    try {
      await downloadReport(payload).then((res) => {
        setCsvLoading(false);
        fileDownload(res?.data, "Webtime Report.csv");
      });
    } catch (error) {
      setCsvLoading(false);
      console.log("error", error);
    }
  };

  return !isLoading ? (
    <div className="timesheet-data-wrapper">
      <div className="timesheet-data">
        <div
          className="d-flex justify-content-between"
          // style={{ width: "100%" }}
        >
          <h3 className="title">My Timesheets</h3>
          <div
            className="custom-date-picker-wrapper d-flex"
            // style={{ display:"flex", position: "relative" }}
          >
            {/* <DateRangePickerComponent /> */}
            <DateRangePicker />
            <MyTimesheetFilters
              filterLoading={filterLoading}
              allCrews={allCrews}
              userOptions={userOptions}
              filterFields={filterFields}
              setFilterFields={setFilterFields}
            />
            {/* <WeekRangePicker
              fetchData={() => console.log("hihi")}
            /> */}
          </div>
        </div>

        <div className="timesheet-flex">
          <div className="timesheet-status open">
            <div className="timesheet-header">
              <h3 className="txt">Open</h3>
            </div>
            <div className="timesheet-content">
              {timeSheetOpen?.length > 0 &&
                timeSheetOpen?.map((card) => {
                  const week = card?.week;
                  const year = week.split("-")[0];
                  const cardWeek = week.split("W")[1];
                  // const projectDescription = projectList?.find(
                  //   (item) => card?.crew?.project_id === item?.id
                  // );
                  const { startDate, endDate } = getStartEndDate(
                    year,
                    cardWeek
                  );

                  return (
                    <div className="status-card">
                      <div className="d-flex justify-content-between flex-wrap">
                        <div>
                          <h5>{card?.crew?.virtual_id}</h5>
                          <div className="crewMember">
                          {
                            card?.crew?._foreman && card?.crew?._general_foreman ? (
                              <p className="smaller-text">
                                <div className="crewMember-fm">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 17.899999618530273 69.30000305175781 35" data-asc="1.058" width="69.30000305175781" height="35"><defs/><g fill="#6b7380"><g transform="translate(0, 0)"><path d="M0 17.90L26 17.90L26.50 28.30L25.60 28.30Q23.75 22.90 21.32 20.95Q18.90 19.00 14.10 19.00L12.70 19.00L12.70 35.25L14.95 35.25Q17.35 35.25 18.95 33.50Q20.55 31.75 21.15 28.70L21.90 28.70L21.90 43.50L21.05 43.50Q20.25 39.75 18.82 38.15Q17.40 36.55 14.95 36.55L12.70 36.55L12.70 51.80L18.90 51.80L18.90 52.90L0 52.90L0 51.80L2.95 51.80L2.95 19.00L0 19.00L0 17.90ZM55.95 17.90L69.30 17.90L69.30 18.85L66.55 18.85L66.55 51.95L69.30 51.95L69.30 52.90L54.05 52.90L54.05 51.95L56.80 51.95L56.80 20.70L56.60 20.70L49.10 52.90L42.85 52.90L34.05 20.55L33.85 20.55L33.85 51.95L36.60 51.95L36.60 52.90L29.80 52.90L29.80 51.95L32.55 51.95L32.55 18.85L29.80 18.85L29.80 17.90L43.30 17.90L49.95 43.65L55.95 17.90Z"/></g></g></svg>
                                  {card?.crew?._foreman }
                                </div>
                                <div className="crewMember-gf">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 17.350000381469727 61.650001525878906 36.05000305175781" data-asc="1.058" width="61.650001525878906" height="36.05000305175781"><defs/><g fill="#6b7380"><g transform="translate(0, 0)"><path d="M17.45 52.40Q19.90 52.40 20.57 51.50Q21.25 50.60 21.25 48.45L21.25 38.75L18.05 38.75L18.05 37.65L32.45 37.65L32.45 38.75L30.50 38.75L30.50 52.85L29.75 52.85Q28.85 51.60 27.20 51.60Q26.50 51.60 23.03 52.50Q19.55 53.40 17.10 53.40Q8.95 53.40 4.47 49.00Q0 44.60 0 35.78Q0 26.95 4.68 22.15Q9.35 17.35 17.25 17.35Q20.30 17.35 23.38 18.13Q26.45 18.90 26.95 18.90Q27.45 18.90 27.70 18.68Q27.95 18.45 28.25 17.90L28.80 17.90L29.20 28.75L28.30 28.75Q25.85 23.90 23.38 21.13Q20.90 18.35 17.85 18.35Q10.20 18.35 10.20 33.30L10.20 37.25Q10.20 44.75 12.07 48.58Q13.95 52.40 17.45 52.40ZM35.15 17.90L61.15 17.90L61.65 28.30L60.75 28.30Q58.90 22.90 56.48 20.95Q54.05 19.00 49.25 19.00L47.85 19.00L47.85 35.25L50.10 35.25Q52.50 35.25 54.10 33.50Q55.70 31.75 56.30 28.70L57.05 28.70L57.05 43.50L56.20 43.50Q55.40 39.75 53.98 38.15Q52.55 36.55 50.10 36.55L47.85 36.55L47.85 51.80L54.05 51.80L54.05 52.90L35.15 52.90L35.15 51.80L38.10 51.80L38.10 19.00L35.15 19.00L35.15 17.90Z"/></g></g></svg>
                                  {card?.crew?._general_foreman}
                                </div>
                              </p>
                            ) : card?.crew?._foreman &&
                              !card?.crew?._general_foreman ? (
                              <p className="smaller-text">
                                <div className="crewMember-fm">
                                  <svg xmlns="http://www.w3.org/2000/svg" style={{"margin-top": "-3px"}} viewBox="0 17.899999618530273 69.30000305175781 35" data-asc="1.058" width="69.30000305175781" height="35"><defs/><g fill="#6b7380"><g transform="translate(0, 0)"><path d="M0 17.90L26 17.90L26.50 28.30L25.60 28.30Q23.75 22.90 21.32 20.95Q18.90 19.00 14.10 19.00L12.70 19.00L12.70 35.25L14.95 35.25Q17.35 35.25 18.95 33.50Q20.55 31.75 21.15 28.70L21.90 28.70L21.90 43.50L21.05 43.50Q20.25 39.75 18.82 38.15Q17.40 36.55 14.95 36.55L12.70 36.55L12.70 51.80L18.90 51.80L18.90 52.90L0 52.90L0 51.80L2.95 51.80L2.95 19.00L0 19.00L0 17.90ZM55.95 17.90L69.30 17.90L69.30 18.85L66.55 18.85L66.55 51.95L69.30 51.95L69.30 52.90L54.05 52.90L54.05 51.95L56.80 51.95L56.80 20.70L56.60 20.70L49.10 52.90L42.85 52.90L34.05 20.55L33.85 20.55L33.85 51.95L36.60 51.95L36.60 52.90L29.80 52.90L29.80 51.95L32.55 51.95L32.55 18.85L29.80 18.85L29.80 17.90L43.30 17.90L49.95 43.65L55.95 17.90Z"/></g></g></svg>
                                  {card?.crew?._foreman }
                                </div>
                              </p>
                            ) : (
                              <p className="smaller-text">
                                {card?.crew?._general_foreman}
                              </p>
                            )
                          }
                          </div>
                        </div>

                        <div className="date-week">
                          <div className="week">{week}</div>
                          <div className="weekStartEnd">{startDate + "-" + endDate}</div>
                        </div>

                      </div>
                      <div className="days-approvals">
                      {isLoadingColor ? (
                        <div className="days">
                          <div className="day">M</div>
                          <div className="day ">T</div>
                          <div className="day">W</div>
                          <div className="day">T</div>
                          <div className="day">F</div>
                          <div className="day">S</div>
                          <div className="day">S</div>
                        </div>
                      ) : (
                        <div className="days">{displayWeeklyData(card.id)}</div>
                      )}
                    </div>
                      <div className="btn-flex">
                        {/* <button
                        onClick={() => {
                          onCardClick(card);
                        }}
                        className="primary-btn open"
                      >
                        View
                      </button>
                      <button
                        onClick={() => {
                          onSubmitClick(card);
                        }}
                        className="primary-btn-outlined"
                      >
                        Submit
                      </button> */}
                        <button
                          onClick={() => {
                            onCardClick(card);
                          }}
                          className="open view-btn"
                        >
                          View{" "}
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye text-slate-400 group-hover/btn:text-amber-500 transition-colors" aria-hidden="true"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
                        </button>
                        {/* <button
                        onClick={() => {
                          onCardClick(card);
                        }}
                        className="primary-btn open recall-btn"
                      >
                        Recall <img src={reloadIcon} className="img-fluid" alt="eyeIcon" />
                      </button> */}
                        <button
                          onClick={() => {
                            onSubmitClick(card);
                          }}
                          className="submit-btn"
                        >
                          Submit{" "}
                         <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-send" aria-hidden="true"><path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"></path><path d="m21.854 2.147-10.94 10.939"></path></svg>
                        </button>
                      </div>
                    </div>
                  );
                })}
              <div className="input-flex">
                {/* <div className="modal-footer"> */}
                <label htmlFor="" className="col-form-label"></label>
                <div className="add-btn-flex">
                  <div  className="addNewTimeSheetContainer">
                    <button
                      // onClick={() => setToggleAddNewMember(true)}
                      type="button"
                      className="addNewTimeSheet"
                      data-bs-toggle="modal"
                      data-bs-target="#addNewTimeSheet"
                    >
                      <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-plus text-slate-500 group-hover:text-amber-700" aria-hidden="true"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>
                      </div>
                      Add New Time Sheet

                    </button>
                  </div>
                </div>

                {/* </div> */}
              </div>
            </div>
            {/* <div className="text-end">
            <button className="primary-btn-outlined new-btn px-3">
              + New Timesheet
            </button>
          </div> */}
          </div>
          <div className="timesheet-status in-review">
            <div className="timesheet-header">
              <h3 className="txt">In Review</h3>
            </div>
            <div className="timesheet-content">
              {timeSheetInReview?.length > 0 &&
                timeSheetInReview?.map((card) => {
                  const week = card?.week;
                  const year = week.split("-")[0];
                  const cardWeek = week.split("W")[1];
                  // const projectDescription = projectList?.find(
                  //   (item) => card?.crew?.project_id === item?.id
                  // );

                  const { startDate, endDate } = getStartEndDate(
                    year,
                    cardWeek
                  );
                  return (
                    <div className="status-card">
                      <div className="d-flex justify-content-between flex-wrap">
                        <div>
                         <h5>{card?.crew?.virtual_id}</h5>
                          <div className="crewMember">
                          {
                            card?.crew?._foreman && card?.crew?._general_foreman ? (
                              <p className="smaller-text">
                                <div className="crewMember-fm">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 17.899999618530273 69.30000305175781 35" data-asc="1.058" width="69.30000305175781" height="35"><defs/><g fill="#6b7380"><g transform="translate(0, 0)"><path d="M0 17.90L26 17.90L26.50 28.30L25.60 28.30Q23.75 22.90 21.32 20.95Q18.90 19.00 14.10 19.00L12.70 19.00L12.70 35.25L14.95 35.25Q17.35 35.25 18.95 33.50Q20.55 31.75 21.15 28.70L21.90 28.70L21.90 43.50L21.05 43.50Q20.25 39.75 18.82 38.15Q17.40 36.55 14.95 36.55L12.70 36.55L12.70 51.80L18.90 51.80L18.90 52.90L0 52.90L0 51.80L2.95 51.80L2.95 19.00L0 19.00L0 17.90ZM55.95 17.90L69.30 17.90L69.30 18.85L66.55 18.85L66.55 51.95L69.30 51.95L69.30 52.90L54.05 52.90L54.05 51.95L56.80 51.95L56.80 20.70L56.60 20.70L49.10 52.90L42.85 52.90L34.05 20.55L33.85 20.55L33.85 51.95L36.60 51.95L36.60 52.90L29.80 52.90L29.80 51.95L32.55 51.95L32.55 18.85L29.80 18.85L29.80 17.90L43.30 17.90L49.95 43.65L55.95 17.90Z"/></g></g></svg>
                                  {card?.crew?._foreman }
                                </div>
                                <div className="crewMember-gf">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 17.350000381469727 61.650001525878906 36.05000305175781" data-asc="1.058" width="61.650001525878906" height="36.05000305175781"><defs/><g fill="#6b7380"><g transform="translate(0, 0)"><path d="M17.45 52.40Q19.90 52.40 20.57 51.50Q21.25 50.60 21.25 48.45L21.25 38.75L18.05 38.75L18.05 37.65L32.45 37.65L32.45 38.75L30.50 38.75L30.50 52.85L29.75 52.85Q28.85 51.60 27.20 51.60Q26.50 51.60 23.03 52.50Q19.55 53.40 17.10 53.40Q8.95 53.40 4.47 49.00Q0 44.60 0 35.78Q0 26.95 4.68 22.15Q9.35 17.35 17.25 17.35Q20.30 17.35 23.38 18.13Q26.45 18.90 26.95 18.90Q27.45 18.90 27.70 18.68Q27.95 18.45 28.25 17.90L28.80 17.90L29.20 28.75L28.30 28.75Q25.85 23.90 23.38 21.13Q20.90 18.35 17.85 18.35Q10.20 18.35 10.20 33.30L10.20 37.25Q10.20 44.75 12.07 48.58Q13.95 52.40 17.45 52.40ZM35.15 17.90L61.15 17.90L61.65 28.30L60.75 28.30Q58.90 22.90 56.48 20.95Q54.05 19.00 49.25 19.00L47.85 19.00L47.85 35.25L50.10 35.25Q52.50 35.25 54.10 33.50Q55.70 31.75 56.30 28.70L57.05 28.70L57.05 43.50L56.20 43.50Q55.40 39.75 53.98 38.15Q52.55 36.55 50.10 36.55L47.85 36.55L47.85 51.80L54.05 51.80L54.05 52.90L35.15 52.90L35.15 51.80L38.10 51.80L38.10 19.00L35.15 19.00L35.15 17.90Z"/></g></g></svg>
                                  {card?.crew?._general_foreman}
                                </div>
                              </p>
                            ) : card?.crew?._foreman &&
                              !card?.crew?._general_foreman ? (
                              <p className="smaller-text">
                                <div className="crewMember-fm">
                                  <svg xmlns="http://www.w3.org/2000/svg" style={{"margin-top": "-3px"}} viewBox="0 17.899999618530273 69.30000305175781 35" data-asc="1.058" width="69.30000305175781" height="35"><defs/><g fill="#6b7380"><g transform="translate(0, 0)"><path d="M0 17.90L26 17.90L26.50 28.30L25.60 28.30Q23.75 22.90 21.32 20.95Q18.90 19.00 14.10 19.00L12.70 19.00L12.70 35.25L14.95 35.25Q17.35 35.25 18.95 33.50Q20.55 31.75 21.15 28.70L21.90 28.70L21.90 43.50L21.05 43.50Q20.25 39.75 18.82 38.15Q17.40 36.55 14.95 36.55L12.70 36.55L12.70 51.80L18.90 51.80L18.90 52.90L0 52.90L0 51.80L2.95 51.80L2.95 19.00L0 19.00L0 17.90ZM55.95 17.90L69.30 17.90L69.30 18.85L66.55 18.85L66.55 51.95L69.30 51.95L69.30 52.90L54.05 52.90L54.05 51.95L56.80 51.95L56.80 20.70L56.60 20.70L49.10 52.90L42.85 52.90L34.05 20.55L33.85 20.55L33.85 51.95L36.60 51.95L36.60 52.90L29.80 52.90L29.80 51.95L32.55 51.95L32.55 18.85L29.80 18.85L29.80 17.90L43.30 17.90L49.95 43.65L55.95 17.90Z"/></g></g></svg>
                                  {card?.crew?._foreman }
                                </div>
                              </p>
                            ) : (
                              <p className="smaller-text">
                                {card?.crew?._general_foreman}
                              </p>
                            )
                          }
                          </div>
                        </div>
                        <div className="date-week">
                          <div className="week">{week}</div>
                          <div className="weekStartEnd">{startDate + "-" + endDate}</div>
                        </div>
                      </div>


                       <div className="days-approvals">
                      {isLoadingColor ? (
                        <div className="days">
                          <div className="day">M</div>
                          <div className="day ">T</div>
                          <div className="day">W</div>
                          <div className="day">T</div>
                          <div className="day">F</div>
                          <div className="day">S</div>
                          <div className="day">S</div>
                        </div>
                      ) : (
                        <div className="days">{displayWeeklyData(card.id)}</div>
                      )}
                      <div className="recall-tick-btn">
                          <span>
                            <div>GF</div>
                            <img
                              src={
                                card?.is_general_manager_approved
                                  ? GreenTick
                                  : GreyTick
                              }
                              alt=""
                            />
                          </span>
                          <span>
                            <div>OM</div>
                            <img
                              src={
                                card?.is_ops_manager_approved
                                  ? GreenTick
                                  : GreyTick
                              }
                              alt=""
                            />
                          </span>
                        </div>
                    </div>



                      <div className="btn-flex">
                        <button
                          onClick={() => {
                            onCardClick(card);
                          }}
                          className="open view-btn"
                        >
                          View{" "}
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye text-slate-400 group-hover/btn:text-amber-500 transition-colors" aria-hidden="true"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
                        </button>

                        {card?.time_sheet_status_id !== 3 && (
                          <button
                            onClick={() => {
                              onClickReturn(card);
                            }}
                            className="open recall-btn"
                          >
                            Recall{" "}
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-rotate-ccw" aria-hidden="true"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path><path d="M3 3v5h5"></path></svg>
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="timesheet-status processed">
            <div className="timesheet-header">
              <h3 className="txt">Processed</h3>
            </div>
            <div className="timesheet-content">
              {timeSheetProcessing?.length > 0 &&
                timeSheetProcessing?.map((card) => {
                  const week = card?.week;
                  const year = week.split("-")[0];
                  const cardWeek = week.split("W")[1];
                  // const projectDescription = projectList?.find(
                  //   (item) => card?.crew?.project_id === item?.id
                  // );
                  const { startDate, endDate } = getStartEndDate(
                    year,
                    cardWeek
                  );

                  return (
                    <div className="status-card">
                      <div className="d-flex justify-content-between flex-wrap">
                        <div>
                         <h5>{card?.crew?.virtual_id}</h5>
                          <div className="crewMember">
                          {
                            card?.crew?._foreman && card?.crew?._general_foreman ? (
                              <p className="smaller-text">
                                <div className="crewMember-fm">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 17.899999618530273 69.30000305175781 35" data-asc="1.058" width="69.30000305175781" height="35"><defs/><g fill="#6b7380"><g transform="translate(0, 0)"><path d="M0 17.90L26 17.90L26.50 28.30L25.60 28.30Q23.75 22.90 21.32 20.95Q18.90 19.00 14.10 19.00L12.70 19.00L12.70 35.25L14.95 35.25Q17.35 35.25 18.95 33.50Q20.55 31.75 21.15 28.70L21.90 28.70L21.90 43.50L21.05 43.50Q20.25 39.75 18.82 38.15Q17.40 36.55 14.95 36.55L12.70 36.55L12.70 51.80L18.90 51.80L18.90 52.90L0 52.90L0 51.80L2.95 51.80L2.95 19.00L0 19.00L0 17.90ZM55.95 17.90L69.30 17.90L69.30 18.85L66.55 18.85L66.55 51.95L69.30 51.95L69.30 52.90L54.05 52.90L54.05 51.95L56.80 51.95L56.80 20.70L56.60 20.70L49.10 52.90L42.85 52.90L34.05 20.55L33.85 20.55L33.85 51.95L36.60 51.95L36.60 52.90L29.80 52.90L29.80 51.95L32.55 51.95L32.55 18.85L29.80 18.85L29.80 17.90L43.30 17.90L49.95 43.65L55.95 17.90Z"/></g></g></svg>
                                  {card?.crew?._foreman }
                                </div>
                                <div className="crewMember-gf">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 17.350000381469727 61.650001525878906 36.05000305175781" data-asc="1.058" width="61.650001525878906" height="36.05000305175781"><defs/><g fill="#6b7380"><g transform="translate(0, 0)"><path d="M17.45 52.40Q19.90 52.40 20.57 51.50Q21.25 50.60 21.25 48.45L21.25 38.75L18.05 38.75L18.05 37.65L32.45 37.65L32.45 38.75L30.50 38.75L30.50 52.85L29.75 52.85Q28.85 51.60 27.20 51.60Q26.50 51.60 23.03 52.50Q19.55 53.40 17.10 53.40Q8.95 53.40 4.47 49.00Q0 44.60 0 35.78Q0 26.95 4.68 22.15Q9.35 17.35 17.25 17.35Q20.30 17.35 23.38 18.13Q26.45 18.90 26.95 18.90Q27.45 18.90 27.70 18.68Q27.95 18.45 28.25 17.90L28.80 17.90L29.20 28.75L28.30 28.75Q25.85 23.90 23.38 21.13Q20.90 18.35 17.85 18.35Q10.20 18.35 10.20 33.30L10.20 37.25Q10.20 44.75 12.07 48.58Q13.95 52.40 17.45 52.40ZM35.15 17.90L61.15 17.90L61.65 28.30L60.75 28.30Q58.90 22.90 56.48 20.95Q54.05 19.00 49.25 19.00L47.85 19.00L47.85 35.25L50.10 35.25Q52.50 35.25 54.10 33.50Q55.70 31.75 56.30 28.70L57.05 28.70L57.05 43.50L56.20 43.50Q55.40 39.75 53.98 38.15Q52.55 36.55 50.10 36.55L47.85 36.55L47.85 51.80L54.05 51.80L54.05 52.90L35.15 52.90L35.15 51.80L38.10 51.80L38.10 19.00L35.15 19.00L35.15 17.90Z"/></g></g></svg>
                                  {card?.crew?._general_foreman}
                                </div>
                              </p>
                            ) : card?.crew?._foreman &&
                              !card?.crew?._general_foreman ? (
                              <p className="smaller-text">
                                <div className="crewMember-fm">
                                  <svg xmlns="http://www.w3.org/2000/svg" style={{"margin-top": "-3px"}} viewBox="0 17.899999618530273 69.30000305175781 35" data-asc="1.058" width="69.30000305175781" height="35"><defs/><g fill="#6b7380"><g transform="translate(0, 0)"><path d="M0 17.90L26 17.90L26.50 28.30L25.60 28.30Q23.75 22.90 21.32 20.95Q18.90 19.00 14.10 19.00L12.70 19.00L12.70 35.25L14.95 35.25Q17.35 35.25 18.95 33.50Q20.55 31.75 21.15 28.70L21.90 28.70L21.90 43.50L21.05 43.50Q20.25 39.75 18.82 38.15Q17.40 36.55 14.95 36.55L12.70 36.55L12.70 51.80L18.90 51.80L18.90 52.90L0 52.90L0 51.80L2.95 51.80L2.95 19.00L0 19.00L0 17.90ZM55.95 17.90L69.30 17.90L69.30 18.85L66.55 18.85L66.55 51.95L69.30 51.95L69.30 52.90L54.05 52.90L54.05 51.95L56.80 51.95L56.80 20.70L56.60 20.70L49.10 52.90L42.85 52.90L34.05 20.55L33.85 20.55L33.85 51.95L36.60 51.95L36.60 52.90L29.80 52.90L29.80 51.95L32.55 51.95L32.55 18.85L29.80 18.85L29.80 17.90L43.30 17.90L49.95 43.65L55.95 17.90Z"/></g></g></svg>
                                  {card?.crew?._foreman }
                                </div>
                              </p>
                            ) : (
                              <p className="smaller-text">
                                {card?.crew?._general_foreman}
                              </p>
                            )
                          }
                          </div>
                        </div>
                        <div className="date-week">
                          <div className="week">{week}</div>
                          <div className="weekStartEnd">{startDate + "-" + endDate}</div>
                        </div>
                      </div>

                      {/* {isLoadingColor ? (
                        <div className="days">
                          <div className="day">M</div>
                          <div className="day ">T</div>
                          <div className="day">W</div>
                          <div className="day">T</div>
                          <div className="day">F</div>
                          <div className="day">S</div>
                          <div className="day">S</div>
                        </div>
                      ) : (
                        // <div className="days">{displayWeeklyData(card.id)}</div>
                        <div className="days">{displayWeeklyData(card.id)}</div>
                      )} */}
                      <div className="btn-flex" style={{ "borderTop": "1px solid oklch(96.8% 0.007 247.896)" , "paddingTop": "8px"}}>
                        <button
                          onClick={() => {
                            onCardClick(card);
                          }}
                          className="open view-btn"
                        >
                          View{" "}
                         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye text-slate-400 group-hover/btn:text-amber-500 transition-colors" aria-hidden="true"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
                        </button>
                        {card?.time_sheet_status_id === 5 && (
                          <button className="primary-btn-outlined complete-btn">
                            Complete{" "}
                            <img
                              src={checkIcon}
                              className="img-fluid"
                              alt="eyeIcon"
                            />
                          </button>
                        )}
                        <button
                          disabled={isLoading}
                          className="report-btn"
                          onClick={() => onClickDownloadReport(card)}
                        >

                          Report{"  "}
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-download" aria-hidden="true"><path d="M12 15V3"></path><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><path d="m7 10 5 5 5-5"></path></svg>
                        </button>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <AddNewTimeSheet
          refreshData={refreshData}
          foremanCrews={foremanCrews}
          allCrews={allCrews}
        />
      </div>
      {csvLoading && <Loader />}
    </div>
  ) : (
    <Loader />
  );
};

export default MyTimesheet;
